import $ from 'jquery';

( function() {

    let dropdown = {

        init: () => {

            dropdown.initList();
            dropdown.stopPropagation();
            dropdown.initValueUpdate();
            dropdown.initValueAmountUpdate();
            dropdown.initCloseOnOutsideClick();
            dropdown.initButtons();
            dropdown.limitSelection();

        },

        // Event-Listener für Dropdowns
        initList: () => {

            $(".dropdown").each( function() {
            
                // Toggle Dropdown-Inhalt beim Klicken
                $(this).on('mousedown', function(e) {
            
                    let $list = $(".dropdown__list", $(this) );
            
                    if( $list.is(":visible") ) {
                        $list.slideUp(100);
                    }
            
                    else {
                        $list.slideDown(100);
                    }
                });
            
            });

        },


        // Schließen der Liste beim Klick innerhalb der Liste verhindern
        stopPropagation: () => {

            $(".dropdown__list", $(".dropdown")).on('mousedown', function( e ) {
                e.stopPropagation();
            });

        },


        // Value aktualisieren und change-Event triggern
        initValueUpdate: () => {

            $(".dropdown__list input").on('change', function() {
            
                let $dropdown = $(this).closest(".dropdown");
                let $list = $(".dropdown__list", $dropdown );
                
                // Values aus der Liste holen und als Array speichern
                let value = $("input:checked", $list).map( function() {
                    return this.value;
                } ).toArray()
            
                // Attribute setzen
                $dropdown.attr( "data-value", JSON.stringify( value ) );

                // Change triggern
                $dropdown.trigger('change');
            
            })

        },


        // Anzahl an ausgewählten Elementen beim Aus-/Abwählen aktualisieren
        initValueAmountUpdate: () => {
             
            $(".dropdown").on('change', function() {
                $(".dropdown-value-amount").html( JSON.parse( $(this).attr("data-value") ).length );
            });

        },


        // Schließen der Liste bei Klick außerhalb der Liste
        initCloseOnOutsideClick: () => {

            // Schließen beim Klick außerhalb der Liste
            $(window).on( 'mousedown', function(e) {

                if( !$(e.target).closest(".dropdown").length ) {
                    $(".dropdown__list").slideUp(100);
                }

            })

        },


        initButtons: () => {

             // Event-Listener für alle Aus-/Abwählen
            $(".dropdown .change-all").on('click', function() {

                let $dropdown = $(this).closest(".dropdown");
                
                // Checkboxen an- oder abwählen
                $(".dropdown__list input", $dropdown ).prop("checked", $(this).data("checked") === true ).trigger('change');    
                
                let hasChecked = $(".dropdown__list input:checked", $dropdown ).length > 0;
                let hasUnchecked = $(".dropdown__list input:not(:checked)", $dropdown ).length > 0;

                $(".change-all--on", $dropdown ).toggleClass("hidden", ! hasUnchecked );
                $(".change-all--off", $dropdown ).toggleClass("hidden", ! hasChecked );


            });


        },

        limitSelection: () => {

            $(".dropdown").on('change', function() {

                // Anzahl der ausgewählten Elemente
                let value = JSON.parse( $(this).attr( "data-value" ) );

                $(".dropdown__list input", $(this) ).prop("disabled", false);

                /**
                 * Mindestanzahl an ausgewählten Elementen
                 * Wenn genauso viele Elemente ausgewählt sind, wie mindestens ausgewählt werden müssen, dann 
                 * werden die noch angehakten Elemente deaktiviert
                 */ 
                let min = $(this).attr("data-min-selected") || 0;

                if( parseInt( min ) === value.length ) {
                    $(".dropdown__list input:checked", $(this) ).prop("disabled", true);
                }

            });

        }


    };

    $(document).ready( dropdown.init );
    

})()
